import React from "react";

/**
 * Bară subțire: întrebări verzi / roșii / neîncercate dintr-un bilet, o temă
 * sau tot setul. Lățimile se schimbă animat.
 */
export default function ProgressSegments({ green = 0, red = 0, total = 0, label, className = "" }) {
   const all = Math.max(0, Number(total) || 0);
   const pct = (n) => (all > 0 ? Math.min(100, (Math.max(0, Number(n) || 0) * 100) / all) : 0);
   return (
      <div className={`progress-segments ${className}`.trim()} role="img" aria-label={label}>
         <span className="progress-segments__ok" style={{ width: `${pct(green)}%` }} />
         <span className="progress-segments__bad" style={{ width: `${pct(red)}%` }} />
      </div>
   );
}
